import { render } from "./HeartRateAlertSettingAddModal.vue?vue&type=template&id=28e5344c&scoped=true&ts=true"
import script from "./HeartRateAlertSettingAddModal.vue?vue&type=script&lang=ts"
export * from "./HeartRateAlertSettingAddModal.vue?vue&type=script&lang=ts"

import "./HeartRateAlertSettingAddModal.vue?vue&type=style&index=0&id=28e5344c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/mingaku/mingaku/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e5344c"]])

export default __exports__